import { create } from 'zustand';

export interface BizyExternalOpenContext {
	source: string;
	pagePath: string;
	pageContext: string;
	starterMessage?: string;
	promptHint?: string;
	/**
	 * Load this existing conversation before applying the starter message.
	 * Set by URL deep links (`?bizy_conversation=<id>`). When present, the
	 * starter message (if any) is sent INTO the loaded conversation rather
	 * than starting a new one, so no "start a new conversation?" conflict
	 * dialog is shown.
	 */
	conversationId?: string;
	/**
	 * When false, the starter message is dropped into the input for the user
	 * to review/edit instead of being sent automatically (URL deep link
	 * `?bizy_prompt_mode=prefill`). Defaults to true (auto-send).
	 */
	autoSend?: boolean;
	/**
	 * Start a fresh conversation before applying the starter, resetting any
	 * active one (no "start a new conversation?" dialog). Set by URL deep links
	 * with a prompt but no `conversationId` — the URL already expresses the
	 * intent (a bare `?bizy_prompt=` is a new topic), so there's no ambiguity
	 * to resolve. Ignored when `conversationId` is set (that targets a specific
	 * conversation). Defaults to false, preserving the feature-request button's
	 * conflict-dialog behavior.
	 */
	forceNewConversation?: boolean;
}

interface BizyExternalOpenStore {
	pendingRequest: BizyExternalOpenContext | null;
	setPendingRequest: (request: BizyExternalOpenContext) => void;
	clearPendingRequest: () => void;
}

export const useBizyExternalOpenStore = create<BizyExternalOpenStore>((set) => ({
	pendingRequest: null,
	setPendingRequest: (request) => set({ pendingRequest: request }),
	clearPendingRequest: () => set({ pendingRequest: null }),
}));
